(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.cj-site-chrome .cjpp-header').forEach(header => {
      if (header.dataset.kpReady) return;
      header.dataset.kpReady = 'true';
      const announcement = header.closest('.shopify-section')?.querySelector('.cjpp-announcement');
      const update = () => {
        if (!header.isConnected) { window.removeEventListener('scroll', update); return; }
        header.classList.toggle('cjpp-header-scrolled', window.scrollY >= (announcement?.offsetHeight || 64));
      };
      window.addEventListener('scroll', update, {passive: true});
      update();
    });
    scope.querySelectorAll('.cj-site-chrome .cjpp-currency select').forEach(select => {
      if (select.dataset.kpReady) return;
      select.dataset.kpReady = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
